var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 126,
    viewBox: "0 0 125 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 64.7104C117.5 60.6479 117.135 56.7417 116.458 52.9917H62.5V75.1792H93.3333C91.9792 82.3146 87.9167 88.3563 81.8229 92.4188V106.846H100.417C111.25 96.8459 117.5 82.1584 117.5 64.7104Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5001 120.7C77.9688 120.7 90.9376 115.596 100.417 106.846L81.823 92.4186C76.7188 95.8561 70.2084 97.9394 62.5001 97.9394C47.6042 97.9394 34.948 87.8874 30.4167 74.3457H11.3542V89.1374C20.7813 107.835 40.1042 120.7 62.5001 120.7Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4166 74.2935C29.2708 70.856 28.5937 67.2101 28.5937 63.408C28.5937 59.606 29.2708 55.9601 30.4166 52.5226V37.731H11.3541C7.44784 45.4393 5.20825 54.1372 5.20825 63.408C5.20825 72.6789 7.44784 81.3768 11.3541 89.0851L26.1978 77.5226L30.4166 74.2935Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5001 28.9292C70.9376 28.9292 78.4376 31.8459 84.4272 37.4709L100.833 21.0646C90.8855 11.7938 77.9688 6.1167 62.5001 6.1167C40.1042 6.1167 20.7813 18.9813 11.3542 37.7313L30.4167 52.5229C34.948 38.9813 47.6042 28.9292 62.5001 28.9292Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.297760669e9d95f0f739374d417ebf8a.svg";
export { ForwardRef as ReactComponent };